import { SnackbarProvider } from "notistack";
import BaseSnackbar from "./BaseSnackbar";

export const KonsolSnackbarProvider = ({ children }) => {
    return (
        <SnackbarProvider
            maxSnack={10}
            anchorOrigin={{
                horizontal: 'right',
                vertical: 'bottom'
            }}
            Components={{
                success: BaseSnackbar,
                error: BaseSnackbar,
                warning: BaseSnackbar,
                info: BaseSnackbar,

            }}
        >
            {children}
        </SnackbarProvider>
    )
}